export default (url, width) => {
  const stringComponents = url?.split('https://res.cloudinary.com/gonation/')

  const optimizedImage = `https://res.cloudinary.com/gonation/w_${1800}/q_auto/f_auto/${stringComponents?.[1]}`

  return optimizedImage
}
